module.exports = __webpack_public_path__ + "static/media/dashboard-reports.1d3c0856.svg";